import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { ComparisonMode, Tab, ViewMode } from '../../containers/process-analysis-v2/process-analysis-v2.type';
import { isLoggingEnabled, logger } from '../logger/logger';
import { getLastMonthDateRange } from './process-analysis-store-v2.helpers';
import { Panel, type State } from './process-analysis-store-v2.type';

const initialState: State = {
  activeTab: Tab.Portfolios,
  viewMode: ViewMode.MeasureComparison,
  comparisonMode: ComparisonMode.Single,
  activePanel: Panel.Filters,
  dateRange: {
    startDate: getLastMonthDateRange().firstDay,
    endDate: getLastMonthDateRange().lastDay,
  },
  availableMeasures: [],
  kpiData: [],
  chartData: null,
  selectedPortfolios: [],
  selectedTeams: [],
  selectedBoards: [],
  selectedMeasures: [],
  selectedMeasureTrends: [],
};

const useProcessAnalysisStore = create<State>()(
  devtools(
    persist(
      logger((_) => ({
        ...initialState,
      })),
      {
        name: 'process-analysis-v2-storage',
        storage: createJSONStorage(() => localStorage),
      },
    ),
    {
      name: 'Bloomfilter - Process Analysis V2 Store',
      enabled: isLoggingEnabled,
    },
  ),
);

export { initialState, useProcessAnalysisStore };
